let cached = null;
let fetchPromise = null;

function doFetch() {
    fetchPromise = fetch('/php/getTurnCredentials.php')
        .then(r => {
            if (!r.ok) throw new Error('TURN credentials fetch failed: ' + r.status);
            return r.json();
        })
        .then(data => { cached = data; return data; })
        .catch(err => { console.warn(err); return null; });
    return fetchPromise;
}

export function prefetchTurnCredentials() {
    if (!cached && !fetchPromise) doFetch();
}

export function getTurnCredentials() {
    if (cached) return Promise.resolve(cached);
    return fetchPromise || doFetch();
}
